<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="subjects"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    clearable
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { Subject, Teaching } from '@/plugins/api'

export default {
  data: () => ({
    subjects: [],
    loading: false
  }),
  props: {
    filter: Object,
    defaultSubjects: Array,
    options: Object
  },
  computed: {
    ...mapGetters('auth', ['role', 'profile'])
  },
  created() {
    if (this.defaultSubjects) {
      this.subjects = this.defaultSubjects
    }

    this.fetchAllSubjects()
  },
  methods: {
    async fetchAllSubjects() {
      this.loading = true
      const params = {
        ...this.filter,
        _limit: -1,
        _sort: 'subjectGroupIndex:asc'
      }

      if (this.role.type === 'teacher' && this.$route.path.includes('marks-input')) {
        // lop giang day
        const teachingParams = {
          teacher: this.profile.id,
          _limit: -1
        }
        const teachings = await Teaching.fetch(teachingParams)
        const teachingSubjectIds = [...new Set(teachings.map(t => t.subject && t.subject.id))]
        params['id_in'] = teachingSubjectIds
      }

      this.subjects = await Subject.fetch(params)
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filter(filter) {
      this.fetchAllSubjects()
    },
    defaultSubjects(subjects) {
      this.subjects = subjects
    }
  }
}
</script>

<style scoped></style>
